import { createContext, useContext, useState } from 'react';
import storage from '../Storage';

let USER_DATA: any = null;

export const setUserDataLocal = (data: any) => {
  USER_DATA = data;
};

export const getUserDataLocal = () => {
  return USER_DATA;
};

interface LoginContextType {
  isLoggedIn: boolean;
  userData: any | null;
  login: (userData: any) => void;
  logout: () => void;
}

const LoginContext = createContext<LoginContextType | undefined>(undefined);

export const useAuth = () => {
  const context = useContext(LoginContext);
  if (!context) {
    throw new Error('useLogin must be used within a LoginProvider');
  }
  return context;
};

export const AuthProvider = ({ children }: any) => {
  const [isLoggedIn, setIsLoggedIn] = useState<boolean>(false);
  const [userData, setUserData] = useState<any | null>(null);

  const login = (userData: any) => {
    setIsLoggedIn(true);
    setUserData(userData);
    setUserDataLocal(userData);
  };

  const logout = () => {
    setIsLoggedIn(false);
    setUserData(null);
    setUserDataLocal(null);
    storage.remove('user');
  };

  return <LoginContext.Provider value={{ isLoggedIn, userData, login, logout }}>{children}</LoginContext.Provider>;
};
